var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 27,
    height: 27,
    rx: 13.5,
    stroke: "#825DFC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8286 8.03823C14.58 8.013 14.3268 8 14.0698 8C10.7176 8 8 10.2122 8 12.9412C8 15.6701 10.7176 17.8824 14.0698 17.8824C14.5938 17.8824 15.1023 17.8283 15.5873 17.7267L17.8635 20V16.8235C18.8853 16.1326 19.7065 15.0942 20 14M20 10.625C20 11.6605 19.1605 12.5 18.125 12.5C17.0895 12.5 16.25 11.6605 16.25 10.625C16.25 9.58947 17.0895 8.75 18.125 8.75C19.1605 8.75 20 9.58947 20 10.625Z",
    stroke: "#825DFC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultCircle);
export default __webpack_public_path__ + "static/media/default-circle.5df3302d3fd4c4a51f3cd0485900eadf.svg";
export { ForwardRef as ReactComponent };